module.exports = __webpack_public_path__ + "img/heart3.b1469542.png";